import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { downloadFile, closeCollapsible, translate, formatDateToPtbr, getUserNameToName } from '../../../../utils/util';
import ContainerService from '../../../../services/ContainerService';
import { Breadcrumbs, Input, Button, Collapsible, Table, Modal } from '../../../../components/UI/ComponentsUI'
import { onValueChange } from '../../../../utils/handleChangeHooks';
import SelectNew from '../../../../components/UI/SelectNew';
import ExplosionContainerDetail from './ExplosionContainerDetail';
import useStateWithPromise from '../../../../utils/useEffectUpdate';

const ExplosionContainer = (props) => {
    const [containers, setContainers] = useState([]);
    const [currentPage, setCurrentPage] = useState({ pageSize: 10, pageIndex: 0, sortField: "", sortOrder: 0 });
    const [filter, setFilter] = useState({ internal: false });
    const [openModal, setOpenModal] = useState(false);
    const [dataModal, setDataModal] = useStateWithPromise({});

    useEffect(() => {
        setContainers(props.containers?.items || []);
        // eslint-disable-next-line
    }, [props?.containers?.items]);

    useEffect(() => {
        onSearch(false);
        // eslint-disable-next-line
    }, [currentPage]);

    const onSearch = (click) => {
        props.getContainers({
            ...filter,
            sortField: currentPage.sortField,
            sortOrder: currentPage.sortOrder,
            PageSize: currentPage.pageSize,
            PageIndex: click ? 0 : currentPage.pageIndex
        });

        closeCollapsible("filterLogs");
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const exportCsv = () => {
        props.exportCsv(filter, (data) => {
            downloadFile(data, `container${Date.now()}.csv`, "data:text/csv", false);
        })
    }

    const exportDetailCsv = (item) => {
        props.exportDetailCsv({ id: item.id }, (data) => {
            downloadFile(data, `containerdetail${Date.now()}.csv`, "data:text/csv", false);
        })
    }


    const onSelectItemChange = (item) => {
        console.log(item)
        setDataModal(item).then(() => {
            setOpenModal(true);
        })
    };

    const configColumn = () => {
        const cols = [
            {
                field: 'id',
                header: "Id",
                align: 'left',
                sortable: false
            },
            {
                field: 'name',
                header: 'Nome Container',
                align: 'left',
                sortable: true
            },
            {
                field: 'statusDescription',
                header: 'Status',
                align: 'left',
                sortable: true
            },
            {
                field: 'supplierName',
                header: 'Fornecedor',
                align: 'left',
                sortable: true
            },
            {
                field: 'containerTypeName',
                header: 'Tipo',
                align: 'left',
                sortable: true
            },
            {
                field: 'containerSizeName',
                header: 'Tamanho',
                align: 'left',
                sortable: true
            },
            {
                field: 'createdOn',
                body: (rowData) => formatDateToPtbr(rowData.createdOn),
                header: 'Data Criação',
                align: 'left',
                sortable: true
            },
            {
                field: 'createdBy',
                header: 'Criado Por',
                body: (rowData) => getUserNameToName(props?.usersFromElog, rowData.updatedBy || rowData.createdBy),
                align: 'left',
            }
        ];
        return cols;
    };

    const configActions = () => [
        {
            // size = 1 é interno
            function: (row) => (
                <i className="material-icons sixth-text-color"
                    onClick={() => onSelectItemChange(row)}
                    title='Ver detalhes'
                    style={{ fontSize: '1.85rem', cursor: 'pointer' }}>visibility</i>
            )
        },
        {
            function: (row) =>
                <i className="material-icons sixth-text-color"
                    onClick={() => exportDetailCsv(row)}
                    title='Excel'
                    style={{ fontSize: '1.85rem', cursor: 'pointer', color: 'green' }}>
                    file_download
                </i>
        }
    ];


    return (
        <div>
            <Breadcrumbs
                title={{ icon: "mdi mdi-view-dashboard-outline", label: "Explosão Container" }} />
            <i className={`mdi mdi-36px mdi-file-excel above-btn`}
                style={{ cursor: 'pointer' }}
                onClick={() => exportCsv()} />
            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <Collapsible
                        id="filterContainer"
                        header={translate('line-picking:linepicking.filter')}
                        body={
                            <>
                                <form id="getReport" className="col s12">
                                    <div className="row" style={{ padding: '10px' }}>
                                        <div className="input-field no-padding col s10">
                                            <Input
                                                id="name"
                                                name='name'
                                                label={translate('resource:name')}
                                                type="text"
                                                value={filter?.name || ''}
                                                onChange={onChange}
                                            />
                                        </div>

                                        <div className="input-field no-padding col s5">
                                            <SelectNew
                                                id="type"
                                                name="type"
                                                value={filter?.type || ''}
                                                change={onChange}
                                                placeHolder={translate('choose-one-option', 'general')}
                                                label={translate('fields.type', 'container')}
                                                data={props.containerTypes?.map((x) => ({ id: x.id, text: x.containerTypeName }))}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <SelectNew
                                                id="size"
                                                name="size"
                                                value={filter?.size || ''}
                                                change={onChange}
                                                placeHolder={translate('choose-one-option', 'general')}
                                                label={translate('fields.size', 'container')}
                                                data={props.containerSizes?.map((x) => ({ id: x.id, text: x.containerSizeName }))}
                                            />
                                        </div>
                                    </div>
                                </form>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button full="true" text="Buscar" onClick={() => onSearch(true)} />
                                </div>
                            </>
                        }
                    />

                </div>
                <Table
                    totalPages={props.containers?.totalPages}
                    current={{ currentPage, setCurrentPage }}
                    col={configColumn()}
                    data={containers}
                    actions={configActions()} />
            </div>
            <Modal
                open={openModal}
                disableAction={true}
                maxHeight="90%"
                id="modalContainerExplosion"
                closeModal={() => {
                    setOpenModal(false);
                    setDataModal({})
                }}
                children={
                    <ExplosionContainerDetail data={dataModal} />
                }
                dismissible={false}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        usersFromElog: state.usersElogReducer.usersElog,
        user: state.userReducer.user,
        containers: state.containerReducer.containers,
        containerSizes: state.containerReducer.containerSizes,
        containerTypes: state.containerReducer.containerTypes
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getContainers: (filter) => {
            dispatch(ContainerService.getContainerExplosionPaged(filter));
        },
        exportCsv: (filter, callback) => {
            dispatch(ContainerService.exportContainerCsv(filter, callback));
        },
        exportDetailCsv: (filter, callback) => {
            dispatch(ContainerService.exportContainerDetailCsv(filter, callback));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ExplosionContainer));
